export const repeatedStringWithRandomStuff = (
  str = "HELLO WORLD",
  stuff = "",
  repeat = 30
) => {
  return str
    .repeat(repeat)
    .split("")
    .reduce((acc, cur, i) => {
      const randomBoolean = Math.random() >= 0.5
      const isEvenNumber = i % 2 == 0
      if (randomBoolean && isEvenNumber) acc.push(cur + stuff)
      else acc.push(cur)
      return acc
    }, [])
    .join("")
}

export const setParam = (key, value) => {
  if (!URL || !URLSearchParams) return

  const url = new URL(window.location.href)
  const params = new URLSearchParams()
  params.set(key, value)
  url.search = params
  const stringifyURL = url.toString()

  // * history.replaceState IE11 - ✓
  window.history.replaceState({ url: stringifyURL }, null, stringifyURL)
}

/**
 * @returns {Object}
 */
export const getViewport = () => {
  const view = { vw: 0, vh: 0 }
  if (!window || !document) return view
  view.vw = Math.max(
    document.documentElement.clientWidth || 0,
    window.innerWidth || 0
  )
  view.vh = Math.max(
    document.documentElement.clientHeight || 0,
    window.innerHeight || 0
  )
  return view
}
